import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button } from 'react-bootstrap';
import cx from 'classnames';

import Loader from '../../Loader';

import history from '../../../core/history';
import messages from '../../../locale/jsonMessages';
import showToaster from '../../../helpers/toasterMessages/showToaster';

import arrow from '/public/siteImages/whiteArrow.svg';

import cs from '../../../components/commonStyle.css';
import s from './Calendar.css';

const BookingButton = (props) => {
    const intl = useIntl();

    const { availability, isDateChosen, basePrice, isHost, bookingProcess, listId, guests } = props;
    const { startDate, endDate, startTime, endTime, options, isHostServiceEligible } = props;
    const { bookingType, bookingLoading, maximumStay, isDisabled, userBanStatus, promoCode } = props;

    const handleClick = () => {
        if (!isHostServiceEligible) {
            showToaster({ messageId: 'hostServiceFeeError', toasterType: 'error' });
            return;
        }
        bookingProcess({ listId, guests, startDate, endDate, startTime, endTime, options, promoCode });
    };

    const handleChange = () => {
        history.push('/s');
    };

    let disabled, buttonLabel;
    disabled = isDisabled || basePrice < 1 || isHost || maximumStay || userBanStatus;
    buttonLabel = bookingType === 'instant' ? messages.bookNow : messages.requestToBook;

    if (!availability && isDateChosen) {
        return (
            <>
                <Button className={cx(cs.btnBig, cs.btnPrimaryBorder, cs.fullWidth)} onClick={handleChange}>
                    <FormattedMessage {...messages.viewOtherListings} />
                </Button>
            </>
        );
    } else {
        return (
            <Loader
                type={"button"}
                className={cx(cs.btnBig, cs.btnPrimary, cs.fullWidth, 'loaderButtonFlex')}
                handleClick={handleClick}
                disabled={disabled}
                show={bookingLoading}
                label={intl.formatMessage(buttonLabel)}
                image={arrow}
            />
        );
    }
};

BookingButton.propTypes = {
    availability: PropTypes.bool.isRequired,
    isDateChosen: PropTypes.bool.isRequired,
    basePrice: PropTypes.number.isRequired,
    isHost: PropTypes.bool.isRequired,
    bookingProcess: PropTypes.any.isRequired,
    listId: PropTypes.number.isRequired,
    guests: PropTypes.number.isRequired,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    bookingType: PropTypes.string.isRequired,
    bookingLoading: PropTypes.bool,
    maximumStay: PropTypes.bool,
    userBanStatus: PropTypes.number,
    isDisabled: PropTypes.bool,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    options: PropTypes.array,
    isHostServiceEligible: PropTypes.bool
};

BookingButton.defaultProps = {
    availability: true,
    isDateChosen: false,
    bookingLoading: false
};

export default withStyles(cs, s)(BookingButton);